import { render, staticRenderFns } from "./Exams.html?vue&type=template&id=11a6d8a7&external"
import script from "./Exams.ts?vue&type=script&lang=ts&external"
export * from "./Exams.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports